<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('ModuleOperationrecord') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('mechanism')">
            <el-select ref="paramOuSelect" v-model="formInline.ouName" style="width:auto" :placeholder="$t('peaseSelect')" :popper-append-to-body="false" @change="changeParamOu" clearable @visible-change="visibleChange">
              <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                <el-tree ref="paramOuTree" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :data="ouList" :props="defaultProps" @node-click="selectParamOu">
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('userNameH')" v-if="!userId">
            <el-input v-model="formInline.userName" clearable :placeholder="$t('userNameH')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('modules')">
            <el-select v-model="formInline.module" clearable :placeholder="$t('modules')" :popper-append-to-body="false">
              <el-option v-for="item of fileType" :key="item.propertyValue" :label="$t(item.propertyValue)" :value="item.propertyValue"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('serialNumberP2')">
            <el-input v-model="formInline.helmetId" clearable :placeholder="$t('serialNumberP')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Recordtime')" class="datetime">
            <el-date-picker v-model="formInline.logDateBegin" :placeholder="$t('startDate')" type="date" value-format="yyyy-MM-dd" popper-class="date-picker-blue-hw" :clearable="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker v-model="formInline.logDateEnd" :placeholder="$t('endDate')" type="date" value-format="yyyy-MM-dd" popper-class="date-picker-blue-hw" :clearable="true">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
            <el-button type="primary" class="serachBtn letter_delet" @click="handleDelet" v-preventReClick="1000" v-has="'sys:new:setting:log:data:delete'">{{ $t('batchDelete') }}</el-button>
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table 组件 -->
        <Table :tableHeight="610" v-loading="loading" :data="tableData" :columns="columns" :operation="dateOperation" :type="type" @getList="getList" @operate="operationEvent" :currentPage="currentPage" :pageSize="pageSize" ref="tanleAssembly"
          :operationWidth="100" @sortChange="handleSort"></Table>
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalData">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import { getModules, deleteModuleLog } from '@/api/log'
import { getOPERATION } from '@/api/setting'
import { getOus } from '@/api/UserList'
import { getExportModules } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  // 实时监控》历史记录》组件弹窗传用户名
  props: {
    userId: {
      type: String,
    },
  },
  data() {
    return {
      ouList: [],
      // 查询表单字段
      formInline: {
        ouName: '',
        ouId: '',
        helmetId: '',
        userName: '',
        logDateBegin: beforeWeekDate(),
        logDateEnd: nowDate(),
        module: '',
      },
      currentPage: 1,
      pageSize: 10,
      // 请求数据的总条数
      totalData: 0,
      // 表头数组
      columns: [],
      // 操作栏数组
      dateOperation: [],
      // table数据
      tableData: [],
      fileType: [],
      // 用于批量删除 公共组件类型判断
      type: 'module',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.formInline.logDateEnd,
        module: this.formInline.module,
        userName: this.formInline.userName,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportModules(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('ModuleOperationrecord') + '.xls')
      })
    },
     // 排序
     handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.column.sortable
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then((res) => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    handleDelet() {
      // 批量删除
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this.delectModuleLog(row)
      }
    },
    //  删除module日志
    delectModuleLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          userId: row.value.userId,
          sid: row.value.sid,
          logTimestamp: row.value.logTimestamp,
        }
        deleteModuleLog(params).then((res) => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.logDateBegin, this.formInline.logDateEnd)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.basicConfig()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.basicConfig()
      }
    },
    // 基础配置数据
    basicConfig() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.formInline.logDateEnd,
        module: this.formInline.module,
        userName: this.formInline.userName,
        userId: this.userId,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      // 请求table数据
      getModules(param).then((res) => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
      // table header
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          sort: 'userName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'module',
          label: this.$t('moduleName'),
          i18n: true,
          sort: 'module',
        },
        {
          attrName: 'eventFmt',
          label: this.$t('eventH'),
          i18n: true,
          align: 'center',
          width: '100',
          sort: 'event',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          align: 'center',
          width: '180',
          sort: 'logTimestamp',
        },
        {
          attrName: 'uploadTimestamp',
          label: this.$t('uploadTimestamp'),
          align: 'center',
          width: '180',
          sort: 'uploadTimestamp',
        },
      ]
      // 操作按钮
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
    // 根据表名查询模块类型
    _getOPERATION() {
      let param = { id: 'HELMET_MODULE' }
      getOPERATION(param).then((res) => {
        if (res.state === 0) {
          this.fileType = res.value
        }
      })
    },
  },
  created() {
    this.basicConfig()
    this._getOPERATION()
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';

>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
>>>.el-popper {
  min-width: 200px !important;
}

.letter_delet {
  margin-left: 10px;
}

.bg-contain .common-table-cnt /deep/ .el-table {
  height: 624px !important;
}

.common-blue-contain {
  .el-pagination {
    margin-top: 18px;
  }
}
</style>
